import { isDev } from "src/features/utils";

interface IDevOnly {
  children: React.ReactNode;
}
export function DevOnly({ children }: IDevOnly) {
  if (!isDev()) return null;
  return <>{children}</>;
}
